export const dummyCardIt = {
  error: false,
  data: {
    list: [
      {
        authorId: 5002256,
        authorName: "easyfly",
        blogId: 4863234,
        blogTitle: "실버를 위한 스마트교육",
        blogImage:
          "https://tistory1.daumcdn.net/tistory/4863234/attach/10ebc030e60241fdb07671c4c29d0a3e",
        blogUrl: "https://easyfly.tistory.com",
        entryThumbnail:
          "https://blog.kakaocdn.net/dn/v4GE5/btsDVpmZGD1/wKJvIP4aLLge5GIF9laTdK/img.jpg",
        entryId: 1083,
        entryTitle: "[git] GitHub의 초대",
        entryUrl: "https://easyfly.tistory.com/1083",
        entrySummary:
          "GitHub의 초대아래 화면은 GitHub에서 선배님이 저를 column 저장소에 협력자로 초대한 것을 보여주는 이메일입니다. 위 화면은 'jognamkim' 사용자인 선배님이 'jognamkim/column' 저장소로의 협업을 위해 저를 초대했습니다.(쓰기 권한이 없어 파일을 push하지는 못했습니다) 물론 초대를 수락하거나 거절할 수 있습니다. 저장소를 확인하거나 해당 사용자의 GitHub 프로필을 방문할 수 있는 링크도 제공됩니다.(메일 가운데 버튼) 초대는 7일 후에 만료되며, 'View invitation' 버튼을 클릭하여 초대에 응답할 수 있습니다. 초대 수락협업을 위해서는 초대에 수락을 해야 합니다. 로그인을 하면 github에 인증 번호 입력 요구가 이어집니다.(로그인 안된 상태에서는 40..",
        serviceCategoryName: "IT 인터넷",
        reactionCount: 175,
        commentCount: 167,
        entryPublished: "2024-01-25T07:22:29+09:00",
        firstReactionCreated: "2024-06-11T15:27:38.076007+09:00",
        isSupportBlog: true,
        supportCount: 2,
        supporters: [
          {
            blogImage:
              "https://tistory1.daumcdn.net/tistory/5656883/attach/6c1cb4cd1f9443ae9cfd4088beb1980a",
          },
          {
            blogImage:
              "https://tistory1.daumcdn.net/tistory/5656883/attach/6c1cb4cd1f9443ae9cfd4088beb1980a",
          },
        ],
      },
      {
        authorId: 6157336,
        authorName: "철수_킴",
        blogId: 6299019,
        blogTitle: "김대리의 월급독립",
        blogImage:
          "https://tistory1.daumcdn.net/tistory/6299019/attach/ef7be523047441da8e93cb9789b31ab5",
        blogUrl: "https://twinleaf-town.tistory.com",
        entryThumbnail:
          "https://blog.kakaocdn.net/dn/llu1s/btsHvs7q9A5/n1gNeUDsjioLizP0NLrk51/img.png",
        entryId: 262,
        entryTitle: "아이폰 배터리 충전 80%까지 제한 멈추는 기능 해제 방법",
        entryUrl:
          "https://twinleaf-town.tistory.com/entry/%EC%95%84%EC%9D%B4%ED%8F%B0-%EB%B0%B0%ED%84%B0%EB%A6%AC-%EC%B6%A9%EC%A0%84-80%EA%B9%8C%EC%A7%80-%EC%A0%9C%ED%95%9C-%EB%A9%88%EC%B6%94%EB%8A%94-%EA%B8%B0%EB%8A%A5-%ED%95%B4%EC%A0%9C-%EB%B0%A9%EB%B2%95",
        entrySummary:
          "아이폰 자체에서 충전 패턴을 학습하여 일정 시간까지 배터리 80%만 충전되는 기능을 해제하는 방법 소개해드립니다.단, 기능을 해제하면 배터리 성능이 저하될 수 도 있습니다.    최적화된 배터리 충전 기능 해제 방법① '설정'을 클릭합니다.   ② '배터리'를 클릭합니다.   ③ '배터리 성능 상태 및 충전'을 클릭합니다.   ④ '최적화된 배터리 충전'을 클릭하여 비활성화 하면 기능이 해제 됩니다.         ▼  함께 보면 좋은 글[IT정보/아이폰] - 아이폰 저전력모드 설정 해제 자동설정으로 배터리 절약 꿀팁 아이폰 저전력모드 설정 해제 자동설정으로 배터리 절약 꿀팁아이폰 \"저전력모드\"란? 외출 전 아이폰 배터리 완충을 하지 못한 상태에서 보조 배터리도 없고 충전기도 찾기 힘들 때 남은 배터리 ..",
        serviceCategoryName: "모바일",
        reactionCount: 2,
        commentCount: 0,
        entryPublished: "2024-06-10T07:16:38+09:00",
        firstReactionCreated: "2024-06-11T15:27:38.086264+09:00",
        isSupportBlog: true,
        supportCount: 0,
        supporters: [],
      },
      {
        authorId: 5862049,
        authorName: "MINK1016",
        blogId: 5949018,
        blogTitle: "당신에게 필요한 모든 정보",
        blogImage:
          "https://tistory1.daumcdn.net/tistory/5949018/attach/34265867ee634c32a571436fc1ae7423",
        blogUrl: "https://mkpark01.tistory.com",
        entryThumbnail:
          "https://blog.kakaocdn.net/dn/bCYLZW/btsHTeVAOXC/4od5eL6vKWBwmjkhM1spok/img.jpg",
        entryId: 1569,
        entryTitle:
          "엣지 컴퓨팅과 클라우드 컴퓨팅의 균형점 (feat. AI가 변화시킨 중심추)",
        entryUrl:
          "https://mkpark01.tistory.com/entry/%EC%97%A3%EC%A7%80-%EC%BB%B4%ED%93%A8%ED%8C%85%EA%B3%BC-%ED%81%B4%EB%9D%BC%EC%9A%B0%EB%93%9C-%EC%BB%B4%ED%93%A8%ED%8C%85%EC%9D%98-%EA%B7%A0%ED%98%95%EC%A0%90-feat-AI%EA%B0%80-%EB%B3%80%ED%99%94%EC%8B%9C%ED%82%A8-%EC%A4%91%EC%8B%AC%EC%B6%94",
        entrySummary:
          "오늘은 지난 3월 엔비디아의 연례행사인 GTC부터 최근의 구글 I/O와 마이크로소프트 빌드를 보면서 느꼈던 한 가지에 대해서 설명해드리려고 합니다. 이 주제는 다음 달에 열리는 애플의 WWDC까지 관통하는 것입니다. 이 주제를 가지고 지금의 인공지능(AI)과 테크 전반을 본다면, 좀 다른 접근을 할 수 있을 것 같습니다. 바로 ‘누가 계산을 하느냐'는 문제입니다. 오늘 주제는 엣지 디바이스와 클라우드 중에 어디서 계산(Where to Compute)’을 할 것인가의 문제입니다. 1. 엣지와 클라우드 : 어디서 계산을 하느냐컴퓨터가 세상에 등장하고 개인용 컴퓨터(PC)가 등장할 때까지, 계산은 항상 중앙화된 서버의 몫이었습니다. 컴퓨팅 파워는 돈이 많은 기업이 소유하고 있었다는 겁니다. 그러다 PC의 등장..",
        serviceCategoryName: "IT 인터넷",
        reactionCount: 27,
        commentCount: 35,
        entryPublished: "2024-06-10T12:06:25+09:00",
        firstReactionCreated: "2024-06-11T15:27:38.089913+09:00",
        isSupportBlog: true,
        supportCount: 0,
        supporters: [],
      },
    ],
    category: "it",
    hasNext: false,
  },
};

export const dummyItemIt = {
  error: false,
  data: {
    lastPublished: 1718063752000,
    list: [
      {
        uniqueId: "6688437_223",
        title:
          "텍스트 데코, 텍스트 대치 변환기,    ҉  글씨를 꾸며주는 글자들의 뜻과 정체",
        summary:
          "텍스트 데코 변환 입출력기 텍스트 입력: 옵션 선택: 글씨 사이에 ҉ 를 겹쳐넣기 글씨 사이에 ҉ 를 집어넣기 글씨 양 옆에 ҉ ♡ ҉ 넣기 글씨 사이에 ҈ 를 겹쳐넣기 글씨 양 옆에 ҈ 를 집어넣기 글씨 사이에 ꙰를 집어넣기 글씨 양 옆에 ꙰를 집어넣기 글씨 위아래 ꙱ 를 집어넣기 글씨 사이에 ͓̽ 위아래 X 넣기 글씨 양 옆에 ͓̽ 위아래 X 넣기 ..",
        userId: 6435540,
        userName: "lovelykorean",
        userImage:
          "https://tistory1.daumcdn.net/tistory/6688437/attach/191ff1ee1a7542e691abaaa880addd06",
        categoryName: "IT 인터넷",
        thumbnail:
          "https://k.kakaocdn.net/dn/bM4zTW/btsHVHwut2m/4QgOWKmlpd6PK6n5zWbeJK/img.png",
        link: "https://lovelykorean.tistory.com/entry/텍스트-데코-텍스트-대치-변환기-҉-글씨를-꾸며주는-글자들의-뜻과-정체",
        blogId: 6688437,
        blogTitle: "lovelykorean",
        likeCount: 6,
        commentCount: 2,
        firstReactionCreated: 1718085536000,
        published: "2024.06.11 14:10",
        publishedAgo: "1시간 전",
        supportCount: 0,
        encodedTitle:
          "%ED%85%8D%EC%8A%A4%ED%8A%B8%20%EB%8D%B0%EC%BD%94%2C%20%ED%85%8D%EC%8A%A4%ED%8A%B8%20%EB%8C%80%EC%B9%98%20%EB%B3%80%ED%99%98%EA%B8%B0%2C%20%20%20%20%D2%89%20%20%EA%B8%80%EC%94%A8%EB%A5%BC%20%EA%BE%B8%EB%A9%B0%EC%A3%BC%EB%8A%94%20%EA%B8%80%EC%9E%90%EB%93%A4%EC%9D%98%20%EB%9C%BB%EA%B3%BC%20%EC%A0%95%EC%B2%B4",
        encodedUserName: "lovelykorean",
      },
      {
        uniqueId: "121803_1994",
        title: "크롬에서 깨진 북마크 한번에 검색하고 삭제하는 방법",
        summary:
          "크롬 브라우저 사용자를 위해 확장프로그램을 사용하여 깨진 북마크를 신속하게 확인하고 제거하는 방법에 대해 설명합니다. Bookmarks Checker 확장 프로그램의 사용법을 자세히 안내하여, 브라우저의 효율성을 개선하는 데 도움을 줍니다.   인터넷을 사용하면서 유용한 웹페이지를 북마크하는 것은 매우 흔한 일입니다. 하지만 시간이 지남에 따라 일부 ..",
        userId: 139589,
        userName: "어떤오후의 프리웨어 이야기",
        userImage:
          "https://tistory1.daumcdn.net/tistory/121803/attach/b9d944c161d84f65ace37cebd82a247a",
        categoryName: "IT 인터넷",
        thumbnail:
          "https://k.kakaocdn.net/dn/dgBRdz/btsHUby6EpQ/yGmrkr035LyhQFCkv6fYAK/img.png",
        link: "https://muzbox.tistory.com/1994",
        blogId: 121803,
        blogTitle: "어떤오후의 프리웨어 이야기 (유용한 IT정보)",
        likeCount: 6,
        commentCount: 1,
        firstReactionCreated: 1718083884000,
        published: "2024.06.11 14:30",
        publishedAgo: "57분 전",
        supportCount: 0,
        encodedTitle:
          "%ED%81%AC%EB%A1%AC%EC%97%90%EC%84%9C%20%EA%B9%A8%EC%A7%84%20%EB%B6%81%EB%A7%88%ED%81%AC%20%ED%95%9C%EB%B2%88%EC%97%90%20%EA%B2%80%EC%83%89%ED%95%98%EA%B3%A0%20%EC%82%AD%EC%A0%9C%ED%95%98%EB%8A%94%20%EB%B0%A9%EB%B2%95",
        encodedUserName:
          "%EC%96%B4%EB%96%A4%EC%98%A4%ED%9B%84%EC%9D%98%20%ED%94%84%EB%A6%AC%EC%9B%A8%EC%96%B4%20%EC%9D%B4%EC%95%BC%EA%B8%B0",
      },
      {
        uniqueId: "6509577_379",
        title:
          "Apple Intelligence가 iOS 18, MacOS Sequoia에 생성 AI를 제공합니다.",
        summary:
          "애플의 AI는 Apple Intelligence입니다.Apple Intelligence는 AI 혁명에 대한 애플의 답변이며 MacOS Sequoia 및 iOS 18에 출시됩니다. 애플(Apple)은 드디어 WWDC 2024에서 AI 기능 제품군을 발표했으며 이를 기기에서 실행되는 Apple Intelligence라고 부릅니다. 애플(Apple)은 A17 Pro와 M 시리즈 칩 덕분에 이 모든 소프트웨어가 사용자의..",
        userId: 1292141,
        userName: "새콤달콤심쿵",
        userImage:
          "https://tistory1.daumcdn.net/tistory/6509577/attach/c6878be8c0894240bf5a1c5c8d89270f",
        categoryName: "IT 인터넷",
        thumbnail:
          "https://k.kakaocdn.net/dn/muXRK/btsHS8QrTJt/XZsqjt5zQqAbNUOhUVvdD1/img.png",
        link: "https://bizstoryway.tistory.com/379",
        blogId: 6509577,
        blogTitle: "새콤달콤한 이야기",
        likeCount: 8,
        commentCount: 9,
        firstReactionCreated: 1718083784000,
        published: "2024.06.11 13:27",
        publishedAgo: "2시간 전",
        supportCount: 0,
        encodedTitle:
          "Apple%20Intelligence%EA%B0%80%20iOS%2018%2C%20MacOS%20Sequoia%EC%97%90%20%EC%83%9D%EC%84%B1%20AI%EB%A5%BC%20%EC%A0%9C%EA%B3%B5%ED%95%A9%EB%8B%88%EB%8B%A4.",
        encodedUserName:
          "%EC%83%88%EC%BD%A4%EB%8B%AC%EC%BD%A4%EC%8B%AC%EC%BF%B5",
      },
      {
        uniqueId: "6509577_378",
        title:
          "iOS 18, iPadOS 18, watchOS 11 및 macOS Sequoia가 지원되는 기기 목록",
        summary:
          "WWDC 2024에서 공개한 OS 지원 기기애플(Apple)은 연례 WWDC 2024 기조연설에서 iOS, iPadOS, macOS, watchOS, tvOS 및 visionOS의 새로운 버전을 발표했습니다. 매년 새로운 기능이 추가되는 것 같습니다. 많은 새로운 기능들이 추가될 예정이며, 그중 상당수는 애플의 새로운 AI 이니셔티브인 Apple Intelligence에 기반을 두고 있습니다.   • iOS..",
        userId: 1292141,
        userName: "새콤달콤심쿵",
        userImage:
          "https://tistory1.daumcdn.net/tistory/6509577/attach/c6878be8c0894240bf5a1c5c8d89270f",
        categoryName: "IT 인터넷",
        thumbnail:
          "https://k.kakaocdn.net/dn/dqZD7m/btsHUDaqka6/U95ECaiobvQANvykTWMkAk/img.png",
        link: "https://bizstoryway.tistory.com/378",
        blogId: 6509577,
        blogTitle: "새콤달콤한 이야기",
        likeCount: 6,
        commentCount: 10,
        firstReactionCreated: 1718080941000,
        published: "2024.06.11 12:53",
        publishedAgo: "2시간 전",
        supportCount: 0,
        encodedTitle:
          "iOS%2018%2C%20iPadOS%2018%2C%20watchOS%2011%20%EB%B0%8F%20macOS%20Sequoia%EA%B0%80%20%EC%A7%80%EC%9B%90%EB%90%98%EB%8A%94%20%EA%B8%B0%EA%B8%B0%20%EB%AA%A9%EB%A1%9D",
        encodedUserName:
          "%EC%83%88%EC%BD%A4%EB%8B%AC%EC%BD%A4%EC%8B%AC%EC%BF%B5",
      },
      {
        uniqueId: "5797996_396",
        title: "애플 노트북 맥북에어 M3 15인치 RAM 16GB 개봉기",
        summary:
          "#맥북에어m315인치 #애플맥북에어 #애플노트북 애플 노트북 맥북에어 M3 15인치 RAM 16GB 개봉기 안녕하세요:-)최근에 맥북에어 m3 15인치 RAM 16기가를 구매했어요. m2랑 m3 둘 중 고민하다가 m3가 맥북프로에 사용된다고 해서이왕 사는거 그래도 최신으로 사자! 싶어서맥북에어M3 8코어 RAM 16GB RAM 256GB로 구매했답니다.  저는 쿠팡으로 ..",
        userId: 5737965,
        userName: "신세임당",
        userImage:
          "https://tistory1.daumcdn.net/tistory/5797996/attach/0c4885d7a0474aefb2611d3421ccc91a",
        categoryName: "IT 제품리뷰",
        thumbnail:
          "https://k.kakaocdn.net/dn/bautV7/btsHVJt6V8X/gj1AzmF8uJ9Gi71XpEdtFk/img.png",
        link: "https://seiming.tistory.com/396",
        blogId: 5797996,
        blogTitle: "Good Health and Long Life.",
        likeCount: 13,
        commentCount: 16,
        firstReactionCreated: 1718080905000,
        published: "2024.06.11 13:30",
        publishedAgo: "1시간 전",
        supportCount: 0,
        encodedTitle:
          "%EC%95%A0%ED%94%8C%20%EB%85%B8%ED%8A%B8%EB%B6%81%20%EB%A7%A5%EB%B6%81%EC%97%90%EC%96%B4%20M3%2015%EC%9D%B8%EC%B9%98%20RAM%2016GB%20%EA%B0%9C%EB%B4%89%EA%B8%B0",
        encodedUserName: "%EC%8B%A0%EC%84%B8%EC%9E%84%EB%8B%B9",
      },
      {
        uniqueId: "571_2492",
        title:
          "“AI 교육과 활용 지침없으면 효율성 떨어져”…AI로 절약한 시간 여전히 관리 업무에 사용",
        summary:
          "AI를 ‘열심히 사용하는 것’과 ‘효과적으로 사용하는 것’은 비슷한 것 같지만 전혀 다른 얘기다. 생성형 AI 등 다양한 AI 도구와 솔루션을 활용해 업무 시간을 절약하는 것은 좋다. 문제는 그다음이다. 그렇게 절약한 시간을 좀 더 가치 있고 부가가치 놓은 일에 사용하고 있는가? 결론은 그렇지 않은 것으로 나타났다.슬랙(Slack)이 워크포스 인덱스(Workforce I..",
        userId: 571,
        userName: "zoomflex",
        userImage:
          "https://tistory1.daumcdn.net/tistory/571/attach/e8090760b6fc435c8528e2d22b1ab36d",
        categoryName: "IT 인터넷",
        thumbnail:
          "https://k.kakaocdn.net/dn/cdSMqd/btsHVxggED9/JGfhV6bcfM4iAEvpt9GD2k/img.jpg",
        link: "https://www.zoominlife.com/2492",
        blogId: 571,
        blogTitle: "ZOOMINLIFE.COM",
        likeCount: 10,
        commentCount: 0,
        firstReactionCreated: 1718078681000,
        published: "2024.06.11 13:04",
        publishedAgo: "2시간 전",
        supportCount: 0,
        encodedTitle:
          "%E2%80%9CAI%20%EA%B5%90%EC%9C%A1%EA%B3%BC%20%ED%99%9C%EC%9A%A9%20%EC%A7%80%EC%B9%A8%EC%97%86%EC%9C%BC%EB%A9%B4%20%ED%9A%A8%EC%9C%A8%EC%84%B1%20%EB%96%A8%EC%96%B4%EC%A0%B8%E2%80%9D%E2%80%A6AI%EB%A1%9C%20%EC%A0%88%EC%95%BD%ED%95%9C%20%EC%8B%9C%EA%B0%84%20%EC%97%AC%EC%A0%84%ED%9E%88%20%EA%B4%80%EB%A6%AC%20%EC%97%85%EB%AC%B4%EC%97%90%20%EC%82%AC%EC%9A%A9",
        encodedUserName: "zoomflex",
      },
      {
        uniqueId: "3264709_1149",
        title:
          "Elon Musk는 iOS 18에 ChatGPT가 통합된 것을 '보안 위반'으로 간주하며 Tesla에서 Apple 기기 사용을 금지할 것이라고 발표했습니다. 이 논란의 배경과 영향에 대해 알아봅니다.",
        summary:
          "ChatGPT 통합된 iOS 18, Tesla에서는 사용 금지? 이유를 알아보자최근 Elon Musk는 iOS 18에 ChatGPT가 통합된 것을 '보안 위반'으로 간주하며 Tesla에서 Apple 기기 사용을 금지할 것이라고 발표했습니다. 이 발표는 기술 업계와 일반 소비자 모두에게 큰 충격을 주었으며, 이번 논란의 배경과 그 영향에 대한 관심이 집중되고 있습니다.1. Elon Musk의 최근 ..",
        userId: 3993000,
        userName: "IT.러쉬맥",
        userImage:
          "https://tistory1.daumcdn.net/tistory/3264709/attach/98787f2d395e4eac9779ae7aa8048cf4",
        categoryName: "IT 인터넷",
        thumbnail:
          "https://k.kakaocdn.net/dn/bwEmH3/btsHTIDqz9R/nKM9xKqmCt3etF34zD3cE0/img.png",
        link: "https://it.rushmac.net/1149",
        blogId: 3264709,
        blogTitle: "IT 정보 개발자Life",
        likeCount: 6,
        commentCount: 7,
        firstReactionCreated: 1718075780000,
        published: "2024.06.11 12:10",
        publishedAgo: "3시간 전",
        supportCount: 0,
        encodedTitle:
          "Elon%20Musk%EB%8A%94%20iOS%2018%EC%97%90%20ChatGPT%EA%B0%80%20%ED%86%B5%ED%95%A9%EB%90%9C%20%EA%B2%83%EC%9D%84%20%27%EB%B3%B4%EC%95%88%20%EC%9C%84%EB%B0%98%27%EC%9C%BC%EB%A1%9C%20%EA%B0%84%EC%A3%BC%ED%95%98%EB%A9%B0%20Tesla%EC%97%90%EC%84%9C%20Apple%20%EA%B8%B0%EA%B8%B0%20%EC%82%AC%EC%9A%A9%EC%9D%84%20%EA%B8%88%EC%A7%80%ED%95%A0%20%EA%B2%83%EC%9D%B4%EB%9D%BC%EA%B3%A0%20%EB%B0%9C%ED%91%9C%ED%96%88%EC%8A%B5%EB%8B%88%EB%8B%A4.%20%EC%9D%B4%20%EB%85%BC%EB%9E%80%EC%9D%98%20%EB%B0%B0%EA%B2%BD%EA%B3%BC%20%EC%98%81%ED%96%A5%EC%97%90%20%EB%8C%80%ED%95%B4%20%EC%95%8C%EC%95%84%EB%B4%85%EB%8B%88%EB%8B%A4.",
        encodedUserName: "IT.%EB%9F%AC%EC%89%AC%EB%A7%A5",
      },
      {
        uniqueId: "7055170_114",
        title: "로얄블러드2_디날왕국연대기_던전공략(굴간동굴)",
        summary:
          "프림델을 구출하면 마이자리온이 합류한다. 마이자리온에는 마녀가 많아서 구출하고 나면 마법력 수급이 원활해지고 레넨볼테라는 주홍기사를 얻을 수 있는데 루난의 창이랑은 아이템을 착용할 수 있다. 마이자리온은 큰 특이사항은 없는 국가라 최후에 구출해도 괜찮다. 주변에 그림쟈크군이 점령할만한 강력한 캐릭도 없고 쉽게 점령되지 않는다.",
        userId: 6664257,
        userName: "넥벤져스1984",
        userImage:
          "https://tistory1.daumcdn.net/tistory/7055170/attach/bec69d14619148e5b3b77f62bac10ffb",
        categoryName: "게임",
        thumbnail:
          "https://k.kakaocdn.net/dn/BAGYK/btsHSzr98cg/zPPt6uETuvzUUvKOLk600k/img.png",
        link: "https://sunrisepark1984.tistory.com/114",
        blogId: 7055170,
        blogTitle: "야구와 게임을 좋아하는 평범한 직장인이야기",
        likeCount: 17,
        commentCount: 13,
        firstReactionCreated: 1718075481000,
        published: "2024.06.11 12:11",
        publishedAgo: "3시간 전",
        supportCount: 0,
        encodedTitle:
          "%EB%A1%9C%EC%96%84%EB%B8%94%EB%9F%AC%EB%93%9C2_%EB%94%94%EB%82%A0%EC%99%95%EA%B5%AD%EC%97%B0%EB%8C%80%EA%B8%B0_%EB%8D%98%EC%A0%84%EA%B3%B5%EB%9E%B5%28%EA%B5%B4%EA%B0%84%EB%8F%99%EA%B5%B4%29",
        encodedUserName: "%EB%84%A5%EB%B2%A4%EC%A0%B8%EC%8A%A41984",
      },
      {
        uniqueId: "6568823_424",
        title:
          "(6월 11일) 24년 6월 데이터무제한 속도 3Mbps 요금제 비교, 추천, 정리, 정보, 요약 - (요금인하) 마블링",
        summary:
          "본 글에서는 기본 데이터 소진 시, 제공되는 무제한 데이터 속도가 3Mbps인 요금제를 정리하였습니다.※ 다른 속도(1Mbps)의 데이터무제한 속도 요금제는 블로그의 해당 글(날짜 최신으로)을 참고하세요. 3Mbps 요금제는 실사용하는 분들이 많이 사용하시는 요금제로 보통 아래와 같은 3가지 종류가 있습니다.기본제공데이터기본제공통화/문자주요 특징15G..",
        userId: 6357780,
        userName: "둥이바보",
        userImage:
          "https://tistory1.daumcdn.net/tistory/6568823/attach/0e280c660e29429b92251141acf1d327",
        categoryName: "모바일",
        thumbnail:
          "https://k.kakaocdn.net/dn/bZfp12/btsHSZsjzG4/fGAah7rmvFdV3AP2L0tnG1/img.png",
        link: "https://jjtwins-family.tistory.com/424",
        blogId: 6568823,
        blogTitle: "사랑이 넘치는 둥이네",
        likeCount: 6,
        commentCount: 5,
        firstReactionCreated: 1718068600000,
        published: "2024.06.11 09:41",
        publishedAgo: "5시간 전",
        supportCount: 0,
        encodedTitle:
          "%286%EC%9B%94%2011%EC%9D%BC%29%2024%EB%85%84%206%EC%9B%94%20%EB%8D%B0%EC%9D%B4%ED%84%B0%EB%AC%B4%EC%A0%9C%ED%95%9C%20%EC%86%8D%EB%8F%84%203Mbps%20%EC%9A%94%EA%B8%88%EC%A0%9C%20%EB%B9%84%EA%B5%90%2C%20%EC%B6%94%EC%B2%9C%2C%20%EC%A0%95%EB%A6%AC%2C%20%EC%A0%95%EB%B3%B4%2C%20%EC%9A%94%EC%95%BD%20-%20%28%EC%9A%94%EA%B8%88%EC%9D%B8%ED%95%98%29%20%EB%A7%88%EB%B8%94%EB%A7%81",
        encodedUserName: "%EB%91%A5%EC%9D%B4%EB%B0%94%EB%B3%B4",
      },
      {
        uniqueId: "5670039_920",
        title: "블로그는 한 가지 전문분야로",
        summary:
          "많은 이들이 공통적으로 외치고 있는 부분이긴 하죠. 일관성과 통일성 이 중요합니다. 블로거들에겐 말이죠. 그래야 블로그 환경 또한 깔끔하고 정갈해 보이기도 합니다. 그래서, 저는 블로그 하면서 생겨나는 에피소드와 블로그 운영 정보들을 공유하며 끄적거림에 가까운 글을 종종 쓰고 있습니다. 글쓰기로 승부보는 시대, 별의별 이야기로 블로깅 하는 시대입..",
        userId: 5635819,
        userName: "에블린엘라",
        userImage:
          "https://tistory1.daumcdn.net/tistory/5670039/attach/1b9835730eb743d3a99ea8627f90f31e",
        categoryName: "IT 인터넷",
        thumbnail:
          "https://k.kakaocdn.net/dn/wL03x/btsHUv4BGWb/DtBFakLRjqwTlEVGgpTMpk/img.jpg",
        link: "https://jean6315.tistory.com/920",
        blogId: 5670039,
        blogTitle: "SPI",
        likeCount: 7,
        commentCount: 0,
        firstReactionCreated: 1718067210000,
        published: "2024.06.11 09:38",
        publishedAgo: "5시간 전",
        supportCount: 0,
        encodedTitle:
          "%EB%B8%94%EB%A1%9C%EA%B7%B8%EB%8A%94%20%ED%95%9C%20%EA%B0%80%EC%A7%80%20%EC%A0%84%EB%AC%B8%EB%B6%84%EC%95%BC%EB%A1%9C",
        encodedUserName: "%EC%97%90%EB%B8%94%EB%A6%B0%EC%97%98%EB%9D%BC",
      },
      {
        uniqueId: "3264709_1148",
        title:
          "iOS 18 업데이트로 아이폰에 T9 다이얼 기능이 추가되었습니다. 새로운 T9 다이얼 기능과 함께 iOS 18의 5가지 핵심 변화를 소개합니다.",
        summary:
          "아이폰 T9 다이얼 가이드: iOS 18에서 새로운 기능 최대한 활용하기iOS 18이 드디어 공개되었습니다. 이번 업데이트는 많은 아이폰 사용자들이 기다려온 혁신적인 기능들을 포함하고 있습니다. 그중에서도 특히 주목받고 있는 것은 바로 T9 다이얼 기능입니다. T9 다이얼 기능을 비롯한 iOS 18의 주요 변화들을 자세히 살펴보겠습니다.1. iOS 18의 주요 업데이트 ..",
        userId: 3993000,
        userName: "IT.러쉬맥",
        userImage:
          "https://tistory1.daumcdn.net/tistory/3264709/attach/98787f2d395e4eac9779ae7aa8048cf4",
        categoryName: "IT 인터넷",
        thumbnail:
          "https://k.kakaocdn.net/dn/MSLCK/btsHUGx3U5w/zRf4LDgPtEBJcbBKVKdvT0/img.png",
        link: "https://it.rushmac.net/1148",
        blogId: 3264709,
        blogTitle: "IT 정보 개발자Life",
        likeCount: 17,
        commentCount: 11,
        firstReactionCreated: 1718066129000,
        published: "2024.06.11 09:35",
        publishedAgo: "5시간 전",
        supportCount: 0,
        encodedTitle:
          "iOS%2018%20%EC%97%85%EB%8D%B0%EC%9D%B4%ED%8A%B8%EB%A1%9C%20%EC%95%84%EC%9D%B4%ED%8F%B0%EC%97%90%20T9%20%EB%8B%A4%EC%9D%B4%EC%96%BC%20%EA%B8%B0%EB%8A%A5%EC%9D%B4%20%EC%B6%94%EA%B0%80%EB%90%98%EC%97%88%EC%8A%B5%EB%8B%88%EB%8B%A4.%20%EC%83%88%EB%A1%9C%EC%9A%B4%20T9%20%EB%8B%A4%EC%9D%B4%EC%96%BC%20%EA%B8%B0%EB%8A%A5%EA%B3%BC%20%ED%95%A8%EA%BB%98%20iOS%2018%EC%9D%98%205%EA%B0%80%EC%A7%80%20%ED%95%B5%EC%8B%AC%20%EB%B3%80%ED%99%94%EB%A5%BC%20%EC%86%8C%EA%B0%9C%ED%95%A9%EB%8B%88%EB%8B%A4.",
        encodedUserName: "IT.%EB%9F%AC%EC%89%AC%EB%A7%A5",
      },
      {
        uniqueId: "5793824_527",
        title: "여행 릴스 쇼츠 추천, 만드는 방법 - 총 21 강",
        summary:
          "강의 목록NOPreview제목 (클릭하세요)1아이폰 2배 줌 사진 꿀팁\uD83D\uDCA12인천공항에서 체코로 순간이동 하기3핸드폰 하나면 열 카메라 부럽지 않은 핵쉬운 촬영 꿀팁 대방출!4\uD83D\uDCF8찍어주고도 욕 먹는 똥\uD83D\uDCA9손들 모여라! 여행 사진 꿀팁! [촬영편]5해시태그 많이 달면 역효과가 난다고요? 여행에미치다 인스타 관리자의 노하우 #여미스쿨6금손처럼 여행 사진 찍는 방..",
        userId: 5438786,
        userName: "에듀모아",
        userImage:
          "https://tistory1.daumcdn.net/tistory/5793824/attach/aa6cf0f816eb443fb896be64bb172b03",
        categoryName: "IT 인터넷",
        thumbnail:
          "https://k.kakaocdn.net/dn/cYHyro/btsHU5c5BnB/vrkA8gQqmVxebEMOy9koCk/img.jpg",
        link: "https://edumoa.tistory.com/527",
        blogId: 5793824,
        blogTitle: "에듀모아 - 유튜브 강의모음",
        likeCount: 15,
        commentCount: 9,
        firstReactionCreated: 1718063752000,
        published: "2024.06.11 08:55",
        publishedAgo: "6시간 전",
        supportCount: 0,
        encodedTitle:
          "%EC%97%AC%ED%96%89%20%EB%A6%B4%EC%8A%A4%20%EC%87%BC%EC%B8%A0%20%EC%B6%94%EC%B2%9C%2C%20%EB%A7%8C%EB%93%9C%EB%8A%94%20%EB%B0%A9%EB%B2%95%20-%20%EC%B4%9D%2021%20%EA%B0%95",
        encodedUserName: "%EC%97%90%EB%93%80%EB%AA%A8%EC%95%84",
      },
    ],
    category: "it",
    hasNext: true,
  },
};

export  const dummyItemIt2 ={
  "error": false,
  "data": {
    "lastPublished": 1718871472000,
    "list": [
      {
        "uniqueId": "3264709_1185",
        "title": "Gmail의 새로운 도구 모음 전환 기능을 사용하여 간단한 도구 모음과 고급 도구 모음 간의 차이점을 알아보고, 효율적으로 이메일을 관리하는 방법을 알아보세요.",
        "summary": "Gmail 도구 모음 전환 기능: 간단한 도구 모음과 고급 도구 모음 비교최근 Gmail은 사용자에게 간단한 도구 모음과 고급 도구 모음 간의 전환 기능을 제공하는 업데이트를 발표했습니다. 이 기능은 이메일 관리와 작업 효율성을 크게 향상하기 위해 설계되었습니다. Gmail의 새로운 도구 모음 전환 기능에 대해 자세히 설명하고, 이를 최대한 활용하는 방법을 안내합..",
        "userId": 3993000,
        "userName": "IT.러쉬맥",
        "userImage": "https://tistory1.daumcdn.net/tistory/3264709/attach/98787f2d395e4eac9779ae7aa8048cf4",
        "categoryName": "IT 인터넷",
        "thumbnail": "https://k.kakaocdn.net/dn/MkvML/btsH6hEz3AZ/Ay7zAtM9wkFNkurrhLyDGK/img.png",
        "link": "https://it.rushmac.net/1185",
        "blogId": 3264709,
        "blogTitle": "IT 정보 개발자Life",
        "likeCount": 19,
        "commentCount": 20,
        "firstReactionCreated": 1718880535000,
        "published": "2024.06.20 19:45",
        "publishedAgo": "2시간 전",
        "supportCount": 0,
        "encodedTitle": "Gmail%EC%9D%98%20%EC%83%88%EB%A1%9C%EC%9A%B4%20%EB%8F%84%EA%B5%AC%20%EB%AA%A8%EC%9D%8C%20%EC%A0%84%ED%99%98%20%EA%B8%B0%EB%8A%A5%EC%9D%84%20%EC%82%AC%EC%9A%A9%ED%95%98%EC%97%AC%20%EA%B0%84%EB%8B%A8%ED%95%9C%20%EB%8F%84%EA%B5%AC%20%EB%AA%A8%EC%9D%8C%EA%B3%BC%20%EA%B3%A0%EA%B8%89%20%EB%8F%84%EA%B5%AC%20%EB%AA%A8%EC%9D%8C%20%EA%B0%84%EC%9D%98%20%EC%B0%A8%EC%9D%B4%EC%A0%90%EC%9D%84%20%EC%95%8C%EC%95%84%EB%B3%B4%EA%B3%A0%2C%20%ED%9A%A8%EC%9C%A8%EC%A0%81%EC%9C%BC%EB%A1%9C%20%EC%9D%B4%EB%A9%94%EC%9D%BC%EC%9D%84%20%EA%B4%80%EB%A6%AC%ED%95%98%EB%8A%94%20%EB%B0%A9%EB%B2%95%EC%9D%84%20%EC%95%8C%EC%95%84%EB%B3%B4%EC%84%B8%EC%9A%94.",
        "encodedUserName": "IT.%EB%9F%AC%EC%89%AC%EB%A7%A5"
      },
      {
        "uniqueId": "6929720_131",
        "title": "갤럭시 안드로이드 핸드폰 해킹 대처법",
        "summary": "2020년에 안드로이드 스마트폰 몇 대가 해킹 위험에 노출되었는 지 아시나요? 약 10억 대의 안드로이드 기기가 해킹에 노출되었었다고 해요. 정말 무시무시한 숫자죠.. ㄷㄷㄷ​​내 기기가 해킹에 취약해지는 이유는 대부분 더 이상 보안 업데이트를 받지 못하는 구 운영 체제를 사용해서인데요. 업데이트를 하라고 알림이 뜰 때마다 바로바로 업데이트를 실행해..",
        "userId": 6586086,
        "userName": "서프샤크",
        "userImage": "https://tistory1.daumcdn.net/tistory/6929720/attach/69d7aef2afc74a1a972bdf9f6348fc70",
        "categoryName": "IT 인터넷",
        "thumbnail": "https://k.kakaocdn.net/dn/bE8z9W/btsH5O4WxsO/sNiqYscuABKFxrNTyUtGkK/img.png",
        "link": "https://surfshark.tistory.com/131",
        "blogId": 6929720,
        "blogTitle": "한국서프샤크",
        "likeCount": 19,
        "commentCount": 15,
        "firstReactionCreated": 1718879104000,
        "published": "2024.06.20 19:22",
        "publishedAgo": "3시간 전",
        "supportCount": 0,
        "encodedTitle": "%EA%B0%A4%EB%9F%AD%EC%8B%9C%20%EC%95%88%EB%93%9C%EB%A1%9C%EC%9D%B4%EB%93%9C%20%ED%95%B8%EB%93%9C%ED%8F%B0%20%ED%95%B4%ED%82%B9%20%EB%8C%80%EC%B2%98%EB%B2%95",
        "encodedUserName": "%EC%84%9C%ED%94%84%EC%83%A4%ED%81%AC"
      },
      {
        "uniqueId": "6509577_390",
        "title": "AI 아트웍, '10대 소녀 스킨 화장품 피부 모델' 표현 - 스테이블 디퓨전(Stable Diffusion)",
        "summary": "AI Artwork, 아트웍 이미지 주제 및 내용지난 한 주 동안, 지인의 부탁으로 '10대 소녀 스킨 화장품 피부 모델' 이미지를 만들어달라는 요청을 받아 포스팅을 잠시 못했는데요. 다음 주에 있을 회사 기획안 발표를 앞두고, 지인은 10대 후반부터 20대 초반을 대상으로 한 기획안을 준비 중이며, 여성 스킨케어 제품에 어울리는 피부가 좋은 소녀 모델을 찾고 ..",
        "userId": 1292141,
        "userName": "새콤달콤심쿵",
        "userImage": "https://tistory1.daumcdn.net/tistory/6509577/attach/c6878be8c0894240bf5a1c5c8d89270f",
        "categoryName": "IT 인터넷",
        "thumbnail": "https://k.kakaocdn.net/dn/dAl1Ox/btsH52IAQyB/Z78U3hL5noOd4QoCzXF6Gk/img.png",
        "link": "https://bizstoryway.tistory.com/390",
        "blogId": 6509577,
        "blogTitle": "새콤달콤한 이야기",
        "likeCount": 72,
        "commentCount": 81,
        "firstReactionCreated": 1718877405000,
        "published": "2024.06.20 18:07",
        "publishedAgo": "4시간 전",
        "supportCount": 0,
        "encodedTitle": "AI%20%EC%95%84%ED%8A%B8%EC%9B%8D%2C%20%2710%EB%8C%80%20%EC%86%8C%EB%85%80%20%EC%8A%A4%ED%82%A8%20%ED%99%94%EC%9E%A5%ED%92%88%20%ED%94%BC%EB%B6%80%20%EB%AA%A8%EB%8D%B8%27%20%ED%91%9C%ED%98%84%20-%20%EC%8A%A4%ED%85%8C%EC%9D%B4%EB%B8%94%20%EB%94%94%ED%93%A8%EC%A0%84%28Stable%20Diffusion%29",
        "encodedUserName": "%EC%83%88%EC%BD%A4%EB%8B%AC%EC%BD%A4%EC%8B%AC%EC%BF%B5"
      },
      {
        "uniqueId": "7057480_10",
        "title": "[엘든 링] 필드 전투와 오픈월드 1",
        "summary": "'엘든 링'은 다크소울 시리즈가 이어오던 소울식 전투 및 게임 시스템에 오픈월드를 접목한 작품입니다. 해당 작은 대중적으로도 큰 성공을 거두었고, 게임성 면에서도 높은 평가를 받았습니다. 이러한 시도는 단순히 게임의 물리적 공간을 넓히는 것을 넘어, 게임플레이의 깊이와 전략성을 한층 강화하는 방향으로 나아갔습니다. 기존의 좁고 어두컴컴한 곳이 주 무..",
        "userId": 6665453,
        "userName": "따뜻한토",
        "userImage": "https://t1.daumcdn.net/tistory_admin/static/manage/images/r3/default_S.png",
        "categoryName": "게임",
        "thumbnail": "https://k.kakaocdn.net/dn/cC4W9X/btsH61aRXcF/BjufEd0ZIZEch7NDIpRhN0/img.png",
        "link": "https://gameanalyze.tistory.com/10",
        "blogId": 7057480,
        "blogTitle": "게임 분석 블로그",
        "likeCount": 26,
        "commentCount": 8,
        "firstReactionCreated": 1718875758000,
        "published": "2024.06.20 18:29",
        "publishedAgo": "4시간 전",
        "supportCount": 0,
        "encodedTitle": "%5B%EC%97%98%EB%93%A0%20%EB%A7%81%5D%20%ED%95%84%EB%93%9C%20%EC%A0%84%ED%88%AC%EC%99%80%20%EC%98%A4%ED%94%88%EC%9B%94%EB%93%9C%201",
        "encodedUserName": "%EB%94%B0%EB%9C%BB%ED%95%9C%ED%86%A0"
      },
      {
        "uniqueId": "5560319_2127",
        "title": "성남 위례 TV 수리, 삼성 TV UN55NU7050FXKR 화면 일부가 흐리게 나와요",
        "summary": "안녕하세요 ~ 성남 태평역 1번 출구바로 앞 1층에 위치한 iPC119입니다.  iPC119에서는 국내외 대부분의 TV 수리가 가능합니다.  이번 수리된 제품은 삼성전자 UN55NU7050FXKR 로화면 일부가 흐리게 나오는 증상으로 입고가 되었습니다. UN55NU7050  UN55NU7050F수리 문의 시 꼭 꼭꼭 참고해 주세요.더보기https://ipc119.tistory.com/notice/1941..",
        "userId": 5547210,
        "userName": "성남 iPC119",
        "userImage": "https://tistory1.daumcdn.net/tistory/5560319/attach/8c4b47382ed041d3bdbd85a2ea4e0788",
        "categoryName": "IT 인터넷",
        "thumbnail": "https://k.kakaocdn.net/dn/9GooE/btsH7k15mQw/tXvuCtmKoLFZhABe5NIVgk/img.jpg",
        "link": "https://lcdas.co.kr/entry/성남-위례-TV-수리-삼성-TV-UN55NU7050FXKR-화면-일부가-흐리게-나와요",
        "blogId": 5560319,
        "blogTitle": "성남컴퓨터수리,아이폰,맥북,노트북,TV수리",
        "likeCount": 24,
        "commentCount": 28,
        "firstReactionCreated": 1718875402000,
        "published": "2024.06.20 18:18",
        "publishedAgo": "4시간 전",
        "supportCount": 0,
        "encodedTitle": "%EC%84%B1%EB%82%A8%20%EC%9C%84%EB%A1%80%20TV%20%EC%88%98%EB%A6%AC%2C%20%EC%82%BC%EC%84%B1%20TV%20UN55NU7050FXKR%20%ED%99%94%EB%A9%B4%20%EC%9D%BC%EB%B6%80%EA%B0%80%20%ED%9D%90%EB%A6%AC%EA%B2%8C%20%EB%82%98%EC%99%80%EC%9A%94",
        "encodedUserName": "%EC%84%B1%EB%82%A8%20iPC119"
      },
      {
        "uniqueId": "387619_607",
        "title": "브라우저 확장 - 자동 로그인 입력기 작성 예제 - Auto Login Extension",
        "summary": "크롬 익스텐션(chrome-extension) 으로 로그인 자동 입력기 \"Auto Login Extension\" 을 작성해 보았습니다.  * 크롬 익스텐션으로 자동 로그인 입력기(Auto Login Extension) 예제 파일 :  크롬 익스텐션(chrome-extension, 크롬 확장 프로그램 ) 개요 크롬 익스텐션(chrome-extension, 크롬 확장 프로그램) 은 구글 크롬 브라우저를 확장하여 사용자에게 ..",
        "userId": 360869,
        "userName": "IT오이시이",
        "userImage": "https://tistory1.daumcdn.net/tistory/387619/attach/8350e97317424bb4865ad156f60e9387",
        "categoryName": "IT 인터넷",
        "thumbnail": "https://k.kakaocdn.net/dn/UAcOe/btsH5lB1gsO/ko2GP0kCh7MZDkh5d0h0o0/img.png",
        "link": "https://couplewith.tistory.com/entry/크롬-익스텐션-자동-로그인-입력기-작성-예제-Auto-Login-Extension",
        "blogId": 387619,
        "blogTitle": "AgileBus - IT 기술자를 위한 최신 기술 Trends",
        "likeCount": 35,
        "commentCount": 42,
        "firstReactionCreated": 1718874013000,
        "published": "2024.06.20 17:17",
        "publishedAgo": "5시간 전",
        "supportCount": 0,
        "encodedTitle": "%EB%B8%8C%EB%9D%BC%EC%9A%B0%EC%A0%80%20%ED%99%95%EC%9E%A5%20-%20%EC%9E%90%EB%8F%99%20%EB%A1%9C%EA%B7%B8%EC%9D%B8%20%EC%9E%85%EB%A0%A5%EA%B8%B0%20%EC%9E%91%EC%84%B1%20%EC%98%88%EC%A0%9C%20-%20Auto%20Login%20Extension",
        "encodedUserName": "IT%EC%98%A4%EC%9D%B4%EC%8B%9C%EC%9D%B4"
      },
      {
        "uniqueId": "290949_7126",
        "title": "레드컬러 무선이어폰 비츠 솔로 버즈!! 10만원대 초반 빨간맛 투명케이스와 이어폰 꽂아봐",
        "summary": "무선이어폰 중에 강열한 컬러의 비츠 솔로 버즈가 10만원대 초반 가격으로 출시되었습니다. 무선이어폰 비츠 솔로 버즈의 빨간맛 투명케이스는 가지고 다닐 수 있지만 빨간색 이어폰은 약간의 용기가 필요하지 않을까 싶습니다. 주위의 시선에 크게 좌우되지 않는 맨탈이라면 세련된 레드컬러의 비즈 솔로 버즈를 고민해 보는 것도 괜찮을 것 같습니다. 개인적으로..",
        "userId": 293941,
        "userName": "핑구야 날자",
        "userImage": "https://tistory1.daumcdn.net/tistory/290949/attach/9dd2e3c29ebc427d81b6b74026e6be48",
        "categoryName": "모바일",
        "thumbnail": "https://k.kakaocdn.net/dn/dDmKiw/btsH6heaoEE/bkixAvx8FQuFpOxsjQOLxK/img.jpg",
        "link": "https://jongamk.tistory.com/7126",
        "blogId": 290949,
        "blogTitle": "핑구야 날자의 IT와 일상",
        "likeCount": 30,
        "commentCount": 28,
        "firstReactionCreated": 1718873821000,
        "published": "2024.06.20 18:01",
        "publishedAgo": "4시간 전",
        "supportCount": 0,
        "encodedTitle": "%EB%A0%88%EB%93%9C%EC%BB%AC%EB%9F%AC%20%EB%AC%B4%EC%84%A0%EC%9D%B4%EC%96%B4%ED%8F%B0%20%EB%B9%84%EC%B8%A0%20%EC%86%94%EB%A1%9C%20%EB%B2%84%EC%A6%88%21%21%2010%EB%A7%8C%EC%9B%90%EB%8C%80%20%EC%B4%88%EB%B0%98%20%EB%B9%A8%EA%B0%84%EB%A7%9B%20%ED%88%AC%EB%AA%85%EC%BC%80%EC%9D%B4%EC%8A%A4%EC%99%80%20%EC%9D%B4%EC%96%B4%ED%8F%B0%20%EA%BD%82%EC%95%84%EB%B4%90",
        "encodedUserName": "%ED%95%91%EA%B5%AC%EC%95%BC%20%EB%82%A0%EC%9E%90"
      },
      {
        "uniqueId": "6858061_816",
        "title": "2024년 새롭게 출시된 M2 아이패드 에어 꼭 사야하는 이유",
        "summary": "2024년 새롭게 출시된 'M2 아이패드 에어'는 강력한 성능과 혁신적인 기능을 갖추고 있어 꼭 구매할 만한 가치가 있는 것으로 평가받고 있습니다. 기존의 '아이패드 프로'에 버금가는 성능으로 새롭게 출시된 'M2 아이패드 에어'의 실제 가치와 활용성가 매우 뛰어나며, 그 인기가 실구매로 이어지고 있다고 하네요. 그럼 새로워진 M2 아이패드 에어에 대해 자세히 ..",
        "userId": 6543597,
        "userName": "친절한 아무개씨",
        "userImage": "https://tistory1.daumcdn.net/tistory/6858061/attach/00fc08c3e7c84d7ebdebf97611fe4099",
        "categoryName": "IT 제품리뷰",
        "thumbnail": "https://k.kakaocdn.net/dn/cN7Kp1/btsH63l335r/aZ6t0Wughy4L0VcuKS8mnK/img.png",
        "link": "https://small-joy.tistory.com/816",
        "blogId": 6858061,
        "blogTitle": "불가근불가원",
        "likeCount": 10,
        "commentCount": 13,
        "firstReactionCreated": 1718873608000,
        "published": "2024.06.20 17:04",
        "publishedAgo": "5시간 전",
        "supportCount": 0,
        "encodedTitle": "2024%EB%85%84%20%EC%83%88%EB%A1%AD%EA%B2%8C%20%EC%B6%9C%EC%8B%9C%EB%90%9C%20M2%20%EC%95%84%EC%9D%B4%ED%8C%A8%EB%93%9C%20%EC%97%90%EC%96%B4%20%EA%BC%AD%20%EC%82%AC%EC%95%BC%ED%95%98%EB%8A%94%20%EC%9D%B4%EC%9C%A0",
        "encodedUserName": "%EC%B9%9C%EC%A0%88%ED%95%9C%20%EC%95%84%EB%AC%B4%EA%B0%9C%EC%94%A8"
      },
      {
        "uniqueId": "5827470_283",
        "title": "방치형 적립 앱테크 \"오테크\" 리뷰, 1000포인트 획득 방법",
        "summary": "최근에 다양한 앱테크로 용돈벌이를 넘어서 부업을 하시는 분들이 많아졌습니다. 저 역시 이전에 다양한 앱테크를 소개해드린 적이 있는데, 아무래도 이런 앱테크들은 하루 1만 보 이상을 걸어야 하거나 설문조사에 참여해야 하거나, 광고시청을 해야 하는 등 직접적으로 내가 움직여야 보상을 받는 경우가 대부분이었습니다. 그런데 오늘 소개해드릴 앱테크는, ..",
        "userId": 5760435,
        "userName": "동구아비",
        "userImage": "https://tistory1.daumcdn.net/tistory/5827470/attach/4fc22e525fc94afa83d5685b3f77a833",
        "categoryName": "모바일",
        "thumbnail": "https://k.kakaocdn.net/dn/7ecB1/btsH5x90JjG/pjRLiW1lidhf9kVf0HULQ0/img.jpg",
        "link": "https://secondmoney10.tistory.com/entry/방치형-적립-앱테크-오테크-리뷰-1000포인트-획득-방법",
        "blogId": 5827470,
        "blogTitle": "복리라이프",
        "likeCount": 16,
        "commentCount": 7,
        "firstReactionCreated": 1718872621000,
        "published": "2024.06.20 17:20",
        "publishedAgo": "5시간 전",
        "supportCount": 0,
        "encodedTitle": "%EB%B0%A9%EC%B9%98%ED%98%95%20%EC%A0%81%EB%A6%BD%20%EC%95%B1%ED%85%8C%ED%81%AC%20%22%EC%98%A4%ED%85%8C%ED%81%AC%22%20%EB%A6%AC%EB%B7%B0%2C%201000%ED%8F%AC%EC%9D%B8%ED%8A%B8%20%ED%9A%8D%EB%93%9D%20%EB%B0%A9%EB%B2%95",
        "encodedUserName": "%EB%8F%99%EA%B5%AC%EC%95%84%EB%B9%84"
      },
      {
        "uniqueId": "5632938_600",
        "title": "LTE 라우터를 통한 데이터 함께쓰기로 스마트하게 인터넷 이용하기",
        "summary": "여러분의 모바일 데이터, 효율적으로 사용하고 계신가요? 데이터가 부족할 때마다 추가 요금을 내거나 와이파이를 찾아 헤매는 일이 번거롭다면, 데이터 함께쓰기를 고려해보세요. 특히 여러 기기를 동시에 사용하는 분들에게 최적의 솔루션이 될 수 있습니다. 데이터 함께쓰기, 어떻게 시작할까요? 통신사에 데이터 함께쓰기 서비스를 신청하세요. SKT와 KT에..",
        "userId": 5605786,
        "userName": "\b애일리언",
        "userImage": "https://tistory1.daumcdn.net/tistory/5632938/attach/39d9ab8f0fca413c88c556a1bb9e90c3",
        "categoryName": "IT 인터넷",
        "thumbnail": "https://k.kakaocdn.net/dn/bpMyXl/btsH5Bq0cqi/GN1gxPtedKEzrv7azHJ491/img.jpg",
        "link": "https://alien711.tistory.com/600",
        "blogId": 5632938,
        "blogTitle": "애일리언",
        "likeCount": 15,
        "commentCount": 18,
        "firstReactionCreated": 1718872350000,
        "published": "2024.06.20 16:48",
        "publishedAgo": "5시간 전",
        "supportCount": 0,
        "encodedTitle": "LTE%20%EB%9D%BC%EC%9A%B0%ED%84%B0%EB%A5%BC%20%ED%86%B5%ED%95%9C%20%EB%8D%B0%EC%9D%B4%ED%84%B0%20%ED%95%A8%EA%BB%98%EC%93%B0%EA%B8%B0%EB%A1%9C%20%EC%8A%A4%EB%A7%88%ED%8A%B8%ED%95%98%EA%B2%8C%20%EC%9D%B8%ED%84%B0%EB%84%B7%20%EC%9D%B4%EC%9A%A9%ED%95%98%EA%B8%B0",
        "encodedUserName": "%08%EC%95%A0%EC%9D%BC%EB%A6%AC%EC%96%B8"
      },
      {
        "uniqueId": "3264709_1184",
        "title": "watchOS 11의 새로운 'Check In' 기능으로 야외 운동을 지원하는 방법! Apple Watch 유저들이 최신 업데이트로 운동 효율을 어떻게 높일 수 있는지 확인해보세요.",
        "summary": "watchOS 11: 새로운 'Check In' 기능으로 야외 운동 지원!Apple의 최신 업데이트인 watchOS 11은 많은 새로운 기능을 제공하며, 그중에서도 'Check In' 기능은 특히 주목할 만합니다. 이 기능은 Apple Watch 사용자들이 야외 운동을 보다 효과적으로 관리하고 즐길 수 있도록 도와줍니다. watchOS 11의 'Check In' 기능이 어떤 특징을 가지고 있으며, 어떻게 야..",
        "userId": 3993000,
        "userName": "IT.러쉬맥",
        "userImage": "https://tistory1.daumcdn.net/tistory/3264709/attach/98787f2d395e4eac9779ae7aa8048cf4",
        "categoryName": "IT 인터넷",
        "thumbnail": "https://k.kakaocdn.net/dn/cuCz8T/btsH40KQNdV/dKQ67oLuvzHkaK1pnKDe2k/img.png",
        "link": "https://it.rushmac.net/1184",
        "blogId": 3264709,
        "blogTitle": "IT 정보 개발자Life",
        "likeCount": 23,
        "commentCount": 25,
        "firstReactionCreated": 1718872219000,
        "published": "2024.06.20 17:25",
        "publishedAgo": "5시간 전",
        "supportCount": 0,
        "encodedTitle": "watchOS%2011%EC%9D%98%20%EC%83%88%EB%A1%9C%EC%9A%B4%20%27Check%20In%27%20%EA%B8%B0%EB%8A%A5%EC%9C%BC%EB%A1%9C%20%EC%95%BC%EC%99%B8%20%EC%9A%B4%EB%8F%99%EC%9D%84%20%EC%A7%80%EC%9B%90%ED%95%98%EB%8A%94%20%EB%B0%A9%EB%B2%95%21%20Apple%20Watch%20%EC%9C%A0%EC%A0%80%EB%93%A4%EC%9D%B4%20%EC%B5%9C%EC%8B%A0%20%EC%97%85%EB%8D%B0%EC%9D%B4%ED%8A%B8%EB%A1%9C%20%EC%9A%B4%EB%8F%99%20%ED%9A%A8%EC%9C%A8%EC%9D%84%20%EC%96%B4%EB%96%BB%EA%B2%8C%20%EB%86%92%EC%9D%BC%20%EC%88%98%20%EC%9E%88%EB%8A%94%EC%A7%80%20%ED%99%95%EC%9D%B8%ED%95%B4%EB%B3%B4%EC%84%B8%EC%9A%94.",
        "encodedUserName": "IT.%EB%9F%AC%EC%89%AC%EB%A7%A5"
      },
      {
        "uniqueId": "6561357_377",
        "title": "NASA 란돌트 임무 승인 지구 궤도 인공 별 띄우는 계획 발표",
        "summary": "1. 지구 궤도 인공 별  미국 항공우주국(NASA)은 최근 '란돌트' 임무를 승인하며, 지구 궤도에 인공 별을 띄우는 계획을 발표했습니다. 이 임무는 1천950만 달러(약 270억 원) 규모로, 2029년에 빵 상자 크기의 소형 위성을 지구 궤도에 발사하는 것을 목표로 하고 있습니다. 이러한 계획은 지구의 대기와 별의 빛을 연구하는 데 큰 도움이 될 것으로 기대되고 있습..",
        "userId": 6351754,
        "userName": "버미70",
        "userImage": "https://tistory1.daumcdn.net/tistory/6561357/attach/212ca988da5445d39a5705c0391fdc41",
        "categoryName": "과학",
        "thumbnail": "https://k.kakaocdn.net/dn/ofuTv/btsH5YMIbP8/fIqhremk7FrwhESDDtHWaK/img.png",
        "link": "https://beomi70.tistory.com/377",
        "blogId": 6561357,
        "blogTitle": "버미의 정원",
        "likeCount": 23,
        "commentCount": 27,
        "firstReactionCreated": 1718871472000,
        "published": "2024.06.20 16:20",
        "publishedAgo": "6시간 전",
        "supportCount": 0,
        "encodedTitle": "NASA%20%EB%9E%80%EB%8F%8C%ED%8A%B8%20%EC%9E%84%EB%AC%B4%20%EC%8A%B9%EC%9D%B8%20%EC%A7%80%EA%B5%AC%20%EA%B6%A4%EB%8F%84%20%EC%9D%B8%EA%B3%B5%20%EB%B3%84%20%EB%9D%84%EC%9A%B0%EB%8A%94%20%EA%B3%84%ED%9A%8D%20%EB%B0%9C%ED%91%9C",
        "encodedUserName": "%EB%B2%84%EB%AF%B870"
      }
    ],
    "category": "it",
    "hasNext": true
  }
}